export default function () {
  return {
    countries: [],
    countriesLoaded: false,
    countriesLoading: false
  }
}
